export const COUNTRIES = {
    'es-mex': {
        language: 'es',
        backendLanguage: 'es',
        locale: 'es-ES',
        hreflang: 'es-mx',
    },
    'es-chl': {
        language: 'es',
        backendLanguage: 'es',
        locale: 'es-ES',
        hreflang: 'es-cl',
    },
    'es-ecu': {
        language: 'es',
        backendLanguage: 'es',
        locale: 'es-ES',
        hreflang: 'es-ec',
    },
    'es-per': {
        language: 'es',
        backendLanguage: 'es',
        locale: 'es-ES',
        hreflang: 'es-pe',
    },
    'es-arg': {
        language: 'es',
        backendLanguage: 'es',
        locale: 'es-ES',
        hreflang: 'es-ar',
    },
    'es-col': {
        language: 'es',
        backendLanguage: 'es',
        locale: 'es-ES',
        hreflang: 'es-co',
    },
    'pt-bra': {
        language: 'pt',
        backendLanguage: 'pt_br',
        locale: 'pt-BR',
        hreflang: 'pt-br',
    },
    'en-usa': {
        language: 'en',
        backendLanguage: 'en_US',
        locale: 'en-US',
        hreflang: 'en-us',
    },
} as const;
